/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Processing.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import Download from 'DesignSystem/Svgs/Download/view.js'
import LoadingBar from 'DesignSystem/LoadingBar/logic.js'
import React from 'react'
import { css } from "emotion"
LoadingBar.displayName = 'LoadingBarLogic'

let styles = {}
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
marginLeft: 6,
marginTop: 1,
marginBottom: 1})

export default function Processing({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/MyAccount/Content/Members/MoreActions/Content/DownloadCSV/Processing"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<div
 data-testid="Processing.Horizontal"
 data-view-path="/App/MyAccount/Content/Members/MoreActions/Content/DownloadCSV/Processing"
 className={`views-block ${styles.Horizontal}`}
>
<Download
 data-testid="Processing.Download"
 data-view-path="/App/MyAccount/Content/Members/MoreActions/Content/DownloadCSV/Processing"
viewPath={`${viewPath}/Download`}
 width={18}
 stroke="#606060"
/>
<LoadingBar
 data-testid="Processing.LoadingBar"
 data-view-path="/App/MyAccount/Content/Members/MoreActions/Content/DownloadCSV/Processing"
viewPath={`${viewPath}/LoadingBar`}
 marginLeft={8}
 alignSelf="center"
 justifySelf="center"
 borderBottomLeftRadius={4}
 borderBottomRightRadius={4}
 borderTopLeftRadius={4}
 borderTopRightRadius={4}
 height={6}
 width="83%"
/>
</div>
{children}
</React.Fragment>)
}